/**
 * Extract mentioned user IDs from a text containing "@name" mentions,
 * matching against a members array. Uses underscored names first
 * (as inserted by MentionInput) then falls back to substring match.
 *
 * Members expected shape: [{ user_id, user_name, name?, user_email }]
 * Returns an array of unique user_id strings.
 */
export function extractMentionUserIds(text, members = []) {
    if (!text || !Array.isArray(members) || members.length === 0) return [];
    const found = new Set();
    const re = /@([A-Za-z0-9_.-]+)/g;
    let match;
    while ((match = re.exec(text)) !== null) {
        const raw = match[1];
        const candidate = raw.replace(/_/g, ' ').toLowerCase();
        // 1) underscored-name exact match (produced by MentionInput)
        let m = members.find(mem => {
            const n = (mem.user_name || mem.name || '').replace(/\s+/g, '_').toLowerCase();
            return n === raw.toLowerCase();
        });
        // 2) name space-matched
        if (!m) {
            m = members.find(mem => (mem.user_name || mem.name || '').toLowerCase() === candidate);
        }
        // 3) email local-part fallback
        if (!m) {
            m = members.find(mem => {
                const email = (mem.user_email || mem.email || '').toLowerCase();
                return email.startsWith(raw.toLowerCase() + '@');
            });
        }
        if (m && m.user_id) found.add(m.user_id);
    }
    return Array.from(found);
}
